import Swiper from 'swiper';
import { Mousewheel, Keyboard, Navigation, Pagination, Scrollbar, Autoplay, EffectCube, EffectFade, EffectCoverflow, EffectCreative, EffectFlip, EffectCards, FreeMode } from 'swiper/modules';

export default class Slider {
    static init = (options = {}) => {
        
        this.initSlider();
        this.initStackedNav();
    }


    static initSlider() {
        let swiperDefaults = {
            modules: [Mousewheel, Keyboard, Navigation, Pagination, Scrollbar, Autoplay, EffectCube, EffectFade, EffectCoverflow, EffectCreative, EffectFlip, EffectCards, FreeMode]
        };

        const elements = document.querySelectorAll(".slider");
        elements.forEach((el) => {
            let data = JSON.parse(el.dataset.swiper || {});

            data = Object.assign({}, swiperDefaults, data);

            new Swiper(el, data);
        });
    }

    static initStackedNav() {
        const stackedNavs = document.querySelectorAll(".stacked-nav");

        let swiperDefaults = {
            modules: [Mousewheel, Keyboard, FreeMode],
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            freeMode: true
        };

        const root = document.getElementsByTagName("body")[0];

        stackedNavs.forEach((stackedNav) => {
            

            const navEl = stackedNav.querySelector(".swiper");

            const swiper = new Swiper(navEl, swiperDefaults);

            const nav = stackedNav.querySelector('.nav')
            const content = stackedNav.querySelector(".content");

            const targets = new Array();

            for (const anchor of nav.querySelectorAll('[href]')) {
                if (!anchor.hash) {
                    continue;
                }

                const obsSection = content.querySelector(anchor.hash);
                if (!obsSection) {
                    continue;
                }

                targets.push({
                    section: obsSection,
                    link: anchor
                });
            }

            let prevYPosition = 0;
            let direction = 'up';

            // Create Observer
            const options = {
                root: root,
                rootMargin: `${nav.offsetHeight * -1 - 10}px 0px -80%`,
                threshold: 0,
            }

            const getTarget = (entry) => targets.find(x => x.section == entry.target);

            const getNextTarget = (entry) => {
                const index = targets.findIndex(x => x.section == entry.target)

                // last item
                if (index >= targets.length - 1) {
                    return targets[index];
                } else {
                    return targets[index + 1];
                }
            }

            const shouldUpdate = (entry) => {
                if (direction === 'down' && !entry.isIntersecting) {
                    return true
                }

                if (direction === 'up' && entry.isIntersecting) {
                    return true
                }

                return false
            }

            const setActive = (target) => {
                targets.forEach(x => {
                    x.link.classList.remove("active");
                });

                target.link.classList.add("active");

                var slideItem = target.link.closest(".swiper-slide");
                var slideIndex = swiper.slides.findIndex(x => x == slideItem);

                swiper.slideTo(slideIndex);
            }

            const onIntersect = (entries) => {
                entries.forEach((entry) => {
                    if (root.scrollTop > prevYPosition) {
                        direction = 'down'
                    } else {
                        direction = 'up'
                    }

                    prevYPosition = root.scrollTop

                    if (shouldUpdate(entry)) {
                        const target = direction === 'down' ? getNextTarget(entry) : getTarget(entry)
                        
                        setActive(target);
                    }
                })
            }

            const observer = new IntersectionObserver(onIntersect, options);

            targets.forEach(target => {
                observer.observe(target.section);
            });
        });
    }
}

